import React, { useEffect, useState } from 'react'
import { Dialog } from 'primereact/dialog';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Button } from '@mui/material';
import { CForm, CRow } from '@coreui/react'
import { useFloor } from '../contexts/FloorContext';
import { useAuth } from '../contexts/AuthContext';
import CInput from './CInput';

function AddFloor({ floorDetail, editFloorId, visible, setVisible, setEditFloorId, editMode, setEditMode, setFloorDetail, setFloorId, fetchFloors, canCreate, canUpdate, canDelete }) {
    const { getSingleFloor, createFloor, updateFloor, deleteFloor } = useFloor()
    const { restaurantId } = useAuth();

    const [validated, setValidated] = useState(false);

    const handleClose = () => {
        setVisible(false);
        setEditMode(false);
        setEditFloorId(null);
        setFloorDetail({
            name: '',
            restaurant_id: restaurantId
        })
        fetchFloors()
    };

    const fetchSingleFloor = async () => {
        try {
            const data = await getSingleFloor(editFloorId);
            setFloorDetail(data.floor);
        } catch (error) {
            console.error('Error fetching single Floor', error);
        }
    };

    useEffect(() => {
        if (editMode && editFloorId) {
            fetchSingleFloor();
        }
    }, [editMode, editFloorId]);

    const handleDelete = async () => {
        try {
            const confirmed = await confirmDelete();

            if (confirmed) {
                await deleteFloor(editFloorId);
                handleClose();
                setFloorId(null)
            }
        } catch (error) {
            console.error('Error during delete operation', error);
        }
    };

    const confirmDelete = async () => {
        return new Promise((resolve) => {
            confirmDialog({
                message: 'Are you sure you want to delete floor?',
                header: 'Delete Confirmation',
                icon: 'pi pi-info-circle',
                position: 'top',
                accept: () => resolve(true),
                reject: () => resolve(false),
            });
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if ((editMode && !canUpdate) || (!editMode && !canCreate)) return;

        const form = e.currentTarget;
        setValidated(true);

        if (form.checkValidity() === false) {
            e.stopPropagation();

            const firstInvalidInput = form.querySelector(':invalid');
            if (firstInvalidInput) {
                firstInvalidInput.focus();
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            try {
                if (visible && restaurantId) {
                    const data = await createFloor({ ...floorDetail, restaurant_id: restaurantId })
                    if (!data.error) {
                        handleClose()
                        setTimeout(() => {
                            setFloorId(data.floor)
                        }, 500);
                    }
                } else if (editMode && editFloorId && restaurantId) {
                    const data = await updateFloor(editFloorId, { ...floorDetail, restaurant_id: restaurantId })
                    if (!data.error) {
                        handleClose()
                        setTimeout(() => {
                            setFloorId(editFloorId)
                        }, 500);
                    }
                }
            } catch (error) {
                console.log(error)
            }
        }
    }

    return (
        <div>
            <ConfirmDialog />
            <Dialog draggable={false} header={`${visible ? 'Create Floor' : 'Edit Floor'}`} visible={visible || (editMode && editFloorId !== null)} style={{ width: '35vw' }} onHide={handleClose}>
                <CForm onSubmit={handleSubmit} noValidate validated={validated}>
                    <div className='fields-container'>
                        <CRow className='mb-4 mt-4'>
                            <CInput
                                label={'Name'}
                                type={'text'}
                                className={'d-flex'}
                                labelClassName={'w-50'}
                                value={floorDetail.name}
                                onChange={(value) => setFloorDetail({ ...floorDetail, name: value })}
                                required={true}
                                errorMessage='Name is required.'
                            />
                        </CRow>
                    </div>
                    <div className={`d-flex button-container ${(editMode && editFloorId && canDelete) ? 'justify-content-between' : 'justify-content-end'}`}>
                        {
                            (editMode && editFloorId && canDelete) && (
                                <div>
                                    <Button color='error' variant="contained" onClick={handleDelete} className='me-2'>
                                        Delete
                                    </Button>
                                </div>
                            )
                        }
                        <div className='d-flex'>
                            <Button onClick={handleClose} fullWidth variant="contained" color="inherit" >
                                Cancel
                            </Button>
                            {((!editMode && canCreate) || (editMode && canUpdate)) && (
                                <Button fullWidth variant="contained" color="primary" type="submit" className="ms-3">
                                    Submit
                                </Button>
                            )}
                        </div>
                    </div>
                </CForm>
            </Dialog>
        </div>
    )
}

export default AddFloor